import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loader',
  inputs:['title'],
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css']
})

export class LoaderComponent  {
	title: string;
	constructor() {
		if (this.title == undefined) {
			this.title = "Loading...";
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/components/utility/loader/loader.component.ts